import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useLocale } from '../Locale';

import I18n from './I18n';
import Link from './Link';

import { createShareUrl } from '../origamiConfig';

const MainFooter = () => {
	const locale = useLocale()
	const location = useLocation();
	const { pathname } = location;

	const urlWithoutLanguage = useMemo(() => {
		const parts = pathname.split('/').slice(1);
		if (parts.length > 1) {
			parts.shift();
		}
		return parts.join('/');
	}, [pathname]);

	function getURL(lang) {
		if(window.location.pathname.indexOf('/share') !== -1 && window.redemptionInfo != null){
			return createShareUrl(lang, {id: window.redemptionInfo.color}, {id: window.redemptionInfo.pattern}, {id: window.redemptionInfo.message});
		}
		return `/${lang}/${urlWithoutLanguage}`;
	}

	return (
		<div className={"main-footer lang-" + locale}>
			<div className="main-footer-content">
				<p>&copy; Nissan {new Date().getFullYear()}</p>
				<Link href={I18n.getTranslation(location, 'general.legalUrl')} text="Legal" />
				<Link href={I18n.getTranslation(location, 'general.eventSelectorUrl')} text="All Events" />
				<span>|</span>
				<Link href={getURL('en')} text="EN" />
				<Link href={getURL('jp')} text="日本語" />
				<Link href={getURL('ar')} text="عربي" />
			</div>
		</div>
	);
};

export default MainFooter;
